import type { RefObject } from 'react';

export type InputFieldRef = RefObject<HTMLInputElement | null | undefined> | undefined;

export function inputText(fieldRef: InputFieldRef): string {
    return fieldRef?.current?.value.trim() ?? '';
}

export function inputHasText(fieldRef: InputFieldRef): boolean {
    return inputText(fieldRef) !== '';
}

export function optionalInputText(fieldRef: InputFieldRef): string | undefined {
    const text = inputText(fieldRef);
    if (text === '') {
        return undefined;
    }

    return text;
}
